const HIDDEN_KEYS = new Set([
  "file_name",
  "file_id",
  "filename",
  "reranker_score",
]);

const REF_LIMIT =
  Number.parseInt(process.env.REACT_APP_DEEP_ANALYSIS_REF_LIMIT || "3", 10) || 3;

export function humanizeKey(key) {
  if (!key) return "";
  return String(key)
    .replace(/_/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/^\w/, (c) => c.toUpperCase());
}

export function isPlainObject(value) {
  return (
    value != null &&
    typeof value === "object" &&
    !Array.isArray(value) &&
    !(value instanceof Date)
  );
}

export function sanitizeObject(obj, hiddenKeys = HIDDEN_KEYS) {
  if (!isPlainObject(obj)) return obj;
  const out = {};
  for (const [k, v] of Object.entries(obj)) {
    if (hiddenKeys?.has?.(k)) continue;
    out[k] = v;
  }
  return out;
}

export function normalizeAnalysisPayload(payload) {
  if (payload == null) return null;
  const candidate =
    payload.deep_analysis ??
    payload.deepAnalysis ??
    payload.result ??
    payload.data ??
    payload.output ??
    payload;
  if (!isPlainObject(candidate)) return null;
  return candidate;
}

export function pickSectionPayload(sectionValue) {
  if (!isPlainObject(sectionValue)) {
    return { response: sectionValue, pmid: undefined, references: undefined };
  }
  const response =
    sectionValue.response ??
    sectionValue.responses ??
    sectionValue.data ??
    sectionValue.result ??
    sectionValue.output ??
    sectionValue;
  const pmid =
    sectionValue.pmid ??
    sectionValue.PMID ??
    sectionValue.pubmed_id ??
    sectionValue.pubmedId ??
    undefined;
  const references =
    sectionValue.references ??
    sectionValue.reference ??
    sectionValue.citations ??
    undefined;
  return { response, pmid, references };
}

export function sanitizeReferences(references, limit = REF_LIMIT) {
  if (Array.isArray(references)) {
    const shown = references.slice(0, Math.max(0, limit));
    return shown.map((r) => sanitizeObject(r, HIDDEN_KEYS));
  }
  return sanitizeObject(references, HIDDEN_KEYS);
}

export { REF_LIMIT, HIDDEN_KEYS };
